export default __webpack_public_path__ + "static/media/fast_win.591be731.svg";